import type { ThirdPartyFeatureSettings } from "@repo/shared/types";
import { useQuery } from "@tanstack/react-query";
import { getThirdPartyFeatures } from "@/lib/api/third-party-features";

/**
 * Current tenant's 3rd-party feature toggles (Whereby, ENIN, Idura, Sinch, …).
 * Shares the ["third-party-features"] cache with the settings page. While loading,
 * callers should treat a flag as enabled (optimistic) to avoid hiding UI before the
 * real value arrives — the server enforces the gate regardless.
 */
export function useThirdPartyFeatures(): {
  features: ThirdPartyFeatureSettings | undefined;
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery({
    queryKey: ["third-party-features"],
    queryFn: () => getThirdPartyFeatures(),
    staleTime: 5 * 60 * 1000,
  });
  return { features: data, isLoading };
}
